// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LMar","title":"Header_title__P8hT5","side":"Header_side__2yMnh"};